import React, { useState, useEffect } from "react";
import { Box, Flex, Heading, Text, useToast } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import useThemeColors from "../../../../../hooks/useThemeColors";
import { textSecondary } from "../../../../../utils/colors";
import ImageUploadNew from "../../../../../components/input/ImageUploadNew";
import { useDispatch, useSelector } from "react-redux";
import { updateTenantLogoAction } from "../../../../../actions/tenantActions";

import SaveButtons from "./SaveButtons";
import { TENANT_UPDATE_LOGO_RESET } from "../../../../../constants/tenantConstants";
// import { useParams } from "react-router-dom";

const ClinicLogo = ({ slug, tenant }) => {
  // GENERAL
  // const { slug } = useParams();
  const { t } = useTranslation();
  const toast = useToast();

  // COLORS
  const { backgroundLightMode, newBorderMode } = useThemeColors();

  // STATE
  const [logo, setLogo] = useState(tenant?.logo);

  const [showButtons, setShowButtons] = useState(false);

  // REDUX
  const dispatch = useDispatch();

  const tenantUpdateLogo = useSelector((state) => state.tenantUpdateLogo);
  const {
    loading: loadingUpdateLogo,
    error: errorUpdateLogo,
    success: successUpdateLogo,
  } = tenantUpdateLogo;

  // HANDLERS
  const updateLogoHandler = () => {
    console.log("Logo URL to be sent:", logo); // ✅ Debugging log

    dispatch(updateTenantLogoAction(slug, tenant.tenantID, logo));
  };

  // USE EFFECT
  useEffect(() => {
    if (logo !== tenant?.logo) {
      setShowButtons(true);
    } else {
      setShowButtons(false);
    }
  }, [logo]);

  useEffect(() => {
    if (successUpdateLogo) {
      toast({
        title: t("toasts.clinicLogoUpdated"),
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      setShowButtons(false);
    } else if (errorUpdateLogo) {
      toast({
        title: t("toasts.clinicLogoUpdatedError"),
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }

    dispatch({ type: TENANT_UPDATE_LOGO_RESET });
  }, [successUpdateLogo, errorUpdateLogo]);

  // LOGS
  // console.log("tenant", tenant);

  return (
    <Box
      w="100%"
      p={["1.5rem 0rem 1.5rem", "3rem 0rem 3rem"]}
      borderBottom={`1px solid ${newBorderMode}`}
    >
      <Flex
        w="100%"
        justify="space-between"
        gap={["1.5rem", "2rem"]}
        direction={["column", "row"]}
      >
        {/* LEFT START */}
        <Flex direction="column" gap={2} w={["100%", "40%"]}>
          <Heading fontSize="1rem" fontWeight="600" p={["0 1.5rem", "initial"]}>
            {t("clinicSettings.logo")}
          </Heading>
          <Text
            color={textSecondary}
            fontSize="sm"
            fontWeight="500"
            p={["0 1.5rem", "initial"]}
          >
            {t("clinicSettings.logoDescription")}
          </Text>
        </Flex>
        {/* LEFT END */}

        {/* RIGHT START */}
        <Flex
          w={["100%", "800px"]}
          direction="column"
          justify="flex-start"
          align="flex-start"
        >
          <Flex
            direction="column"
            w="100%"
            bg={backgroundLightMode}
            borderRadius={["0rem", "1rem"]}
            p="1.25rem 1.5rem 1.25rem"
          >
            <ImageUploadNew
              image={logo}
              setImage={setLogo}
              w="80px"
              h="80px"
              isLogo
              noToasts
            />
          </Flex>
        </Flex>
        {/* RIGHT END  */}
      </Flex>

      {/* BUTTONS */}
      {showButtons && (
        <SaveButtons
          onClose={() => {
            setShowButtons(false);
            setLogo(tenant?.logo);
          }}
          onClick={updateLogoHandler}
          loading
        />
      )}
    </Box>
  );
};

export default ClinicLogo;
